var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import "./style.scss";
import pubsub from "@viewlift/pubsub";
import { publishVerticalMastheadStatus, subscribeVerticalMastheadStatus } from './verticalMasthead.event';
import { checkForHBA, getFlowSteps, getTVProviderLogo, handleSeviceTypes, switchBetweenPages } from "../../helpers";
import { siteConfigParser } from '../../helpers/siteConfigParser';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Navigation from '../MastheadModule/navigation';
import { SubscribeButton } from '../MastheadModule/subscribeButton';
import { getFontsStyles } from '../TrayModules/Helper/helper';
import localforage from 'localforage';
import { LoginButton } from '../MastheadModule/loginButton';
import { logout } from "../../MFEs/web-authentication-sdk/src/logic/login/logOut";
import Cookies from 'js-cookie';
import { ANALYTICS } from "../../helpers/analyticsMap";
var VerticalMasthead = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    var pageData = _a.pageData, siteConfig = _a.siteConfig;
    var navigate = useNavigate();
    var moduleData = pageData === null || pageData === void 0 ? void 0 : pageData.filter(function (module) { return (module === null || module === void 0 ? void 0 : module.moduleType) === "MastheadModule"; });
    var pathname = useLocation().pathname;
    var _7 = __read(useSearchParams(), 1), searchParams = _7[0];
    var _8 = __read(useState(false), 2), userMenu = _8[0], setUserMenu = _8[1];
    var _9 = __read(useState(null), 2), mvpd = _9[0], setMvpd = _9[1];
    var _10 = __read(useState(false), 2), showMasthead = _10[0], setShowMasthead = _10[1];
    var _11 = __read(useState(null), 2), mvpdLogo = _11[0], setMvpdLogo = _11[1];
    var _12 = __read(useState(false), 2), isAppAccessing = _12[0], setIsAppAccessing = _12[1];
    var _13 = __read(useState([]), 2), navigationItems = _13[0], setNavigationItems = _13[1];
    var _14 = __read(useState(pathname.includes("/search")), 2), showSearchbox = _14[0], setShowSearchbox = _14[1];
    var desktopLogo = siteConfigParser((_b = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.images, "desktopLogo");
    var _15 = getFontsStyles(moduleData && ((_d = (_c = moduleData === null || moduleData === void 0 ? void 0 : moduleData[0]) === null || _c === void 0 ? void 0 : _c.layout) === null || _d === void 0 ? void 0 : _d.fontSetting), (_f = (_e = moduleData === null || moduleData === void 0 ? void 0 : moduleData[0]) === null || _e === void 0 ? void 0 : _e.layout) === null || _f === void 0 ? void 0 : _f.settings), navigationFonts = _15.navigationFonts, logoutCta = _15.logoutCta, connectTvProviderCta = _15.connectTvProviderCta;
    var sponserLogo = moduleData && ((_j = (_h = (_g = moduleData === null || moduleData === void 0 ? void 0 : moduleData[0]) === null || _g === void 0 ? void 0 : _g.layout) === null || _h === void 0 ? void 0 : _h.settings) === null || _j === void 0 ? void 0 : _j.sponsorLogo);
    var navigationSettings = (_m = (_l = (_k = window.app_data) === null || _k === void 0 ? void 0 : _k.appcmsPlatform) === null || _l === void 0 ? void 0 : _l.navigation) === null || _m === void 0 ? void 0 : _m.user;
    var navigationPlacement = (moduleData && ((_q = (_p = (_o = moduleData === null || moduleData === void 0 ? void 0 : moduleData[0]) === null || _o === void 0 ? void 0 : _o.layout) === null || _p === void 0 ? void 0 : _p.settings) === null || _q === void 0 ? void 0 : _q.navigationPlacement)) || 'Top';
    var _16 = ((_s = (_r = moduleData === null || moduleData === void 0 ? void 0 : moduleData[0]) === null || _r === void 0 ? void 0 : _r.layout) === null || _s === void 0 ? void 0 : _s.settings) || {}, connectTvProviderCtaBgColor = _16.connectTvProviderCtaBgColor, connectTvProviderCtaBorderColor = _16.connectTvProviderCtaBorderColor, connectTvProviderCtaTextColor = _16.connectTvProviderCtaTextColor;
    var connectTvProviderCtaStyle = {
        backgroundColor: connectTvProviderCtaBgColor,
        color: connectTvProviderCtaTextColor,
        borderColor: connectTvProviderCtaBorderColor
    };
    var serviceTypes = handleSeviceTypes();
    var _17 = __read(useState({
        user: {
            isSubscribed: false,
            userId: "",
            provider: "",
            tveUserId: ""
        },
    }), 2), access = _17[0], setAccess = _17[1];
    var searchConfig = (_v = (_u = (_t = window === null || window === void 0 ? void 0 : window.app_data) === null || _t === void 0 ? void 0 : _t.appcmsMain) === null || _u === void 0 ? void 0 : _u.searchConfig) !== null && _v !== void 0 ? _v : null;
    useEffect(function () {
        var handleHeaderPosition = function () {
            if (window.innerWidth <= 1200) {
                publishVerticalMastheadStatus(false);
            }
            else if (navigationPlacement === 'Left') {
                publishVerticalMastheadStatus(true);
            }
            else {
                publishVerticalMastheadStatus(false);
            }
        };
        subscribeVerticalMastheadStatus(handleVerticalNavigation);
        handleHeaderPosition();
        window.addEventListener('resize', handleHeaderPosition);
        return function () { return window.removeEventListener('resize', handleHeaderPosition); };
    }, []);
    useEffect(function () {
        localforage
            .getItem("AuthenticationStore")
            .then(function (store) {
            var _a, _b, _c, _d;
            if (store && typeof store.user == "object")
                setAccess(store);
            if (store && ((_b = (_a = store === null || store === void 0 ? void 0 : store.user) === null || _a === void 0 ? void 0 : _a.tveMetadata) === null || _b === void 0 ? void 0 : _b.mvpdProvider)) {
                var mvpd_1 = (_d = (_c = store === null || store === void 0 ? void 0 : store.user) === null || _c === void 0 ? void 0 : _c.tveMetadata) === null || _d === void 0 ? void 0 : _d.mvpdProvider;
                setMvpd(mvpd_1);
                setMvpdLogo(getTVProviderLogo(mvpd_1));
            }
        })
            .catch(function (err) {
            console.log(err);
            return;
        });
        checkToShow(navigationSettings).then(function (navList) {
            setNavigationItems(navList);
        });
        appAccessEnabler();
        // handleUserLoggedState();
    }, []);
    var handleVerticalNavigation = function (status) {
        setShowMasthead(status);
    };
    function getQueryParams(qs) {
        var _a;
        var paramString = (qs === null || qs === void 0 ? void 0 : qs.split('?').length) > 0 ? qs === null || qs === void 0 ? void 0 : qs.split('?')[1] : null;
        if (paramString) {
            var params_arr = paramString.split('&') || [paramString];
            for (var i = 0; i < params_arr.length; i++) {
                var pair = (_a = params_arr[i]) === null || _a === void 0 ? void 0 : _a.split('=');
                if (pair.includes('app'))
                    setIsAppAccessing(true);
            }
        }
    }
    var appAccessEnabler = function () {
        getQueryParams(window.location.href);
    };
    var getBackgroundColor = function () {
        var _a, _b, _c;
        var bgColor = (_c = (_b = (_a = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsMain) === null || _a === void 0 ? void 0 : _a.brand) === null || _b === void 0 ? void 0 : _b.navigation) === null || _c === void 0 ? void 0 : _c.backgroundColor;
        return isAppAccessing ? { backgroundColor: bgColor, display: 'none' } : { backgroundColor: bgColor };
    };
    var checkToShow = function (navigation) { return __awaiter(void 0, void 0, void 0, function () {
        var AuthenticationStore, user, isSubscribed, isTveLoggedIn, navList, i, isToShow;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        return __generator(this, function (_r) {
            switch (_r.label) {
                case 0: return [4 /*yield*/, localforage.getItem('AuthenticationStore')];
                case 1:
                    AuthenticationStore = _r.sent();
                    user = AuthenticationStore === null || AuthenticationStore === void 0 ? void 0 : AuthenticationStore.user;
                    isSubscribed = (user === null || user === void 0 ? void 0 : user.isSubscribed) || false;
                    isTveLoggedIn = ((_a = user === null || user === void 0 ? void 0 : user.tveMetadata) === null || _a === void 0 ? void 0 : _a.tveProvider) ? true : false;
                    navList = [];
                    for (i = 0; i < navigation.length; i++) {
                        isToShow = false;
                        if (user && !isToShow) { //if logged in
                            if (isSubscribed && isTveLoggedIn) {
                                isToShow = ((_c = (_b = navigation[i]) === null || _b === void 0 ? void 0 : _b.accessLevels) === null || _c === void 0 ? void 0 : _c.subscribed) || ((_e = (_d = navigation[i]) === null || _d === void 0 ? void 0 : _d.accessLevels) === null || _e === void 0 ? void 0 : _e.tve);
                            }
                            else if (isTveLoggedIn && !isSubscribed && !isToShow) {
                                isToShow = ((_g = (_f = navigation[i]) === null || _f === void 0 ? void 0 : _f.accessLevels) === null || _g === void 0 ? void 0 : _g.tve) ? true : false;
                            }
                            else if (!isTveLoggedIn && isSubscribed && !isToShow) {
                                isToShow = ((_j = (_h = navigation[i]) === null || _h === void 0 ? void 0 : _h.accessLevels) === null || _j === void 0 ? void 0 : _j.subscribed) ? true : false;
                            }
                            else {
                                isToShow = ((_l = (_k = navigation[i]) === null || _k === void 0 ? void 0 : _k.accessLevels) === null || _l === void 0 ? void 0 : _l.loggedIn) ? true : false;
                            }
                        }
                        else {
                            isToShow = ((_o = (_m = navigation[i]) === null || _m === void 0 ? void 0 : _m.accessLevels) === null || _o === void 0 ? void 0 : _o.loggedOut) ? true : false;
                        }
                        if (isToShow) {
                            if (((_q = (_p = navigation[i]) === null || _p === void 0 ? void 0 : _p.url) === null || _q === void 0 ? void 0 : _q.includes("search")) && !(searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.isEnabled))
                                continue;
                            navList.push(navigation[i]);
                        }
                    }
                    return [2 /*return*/, navList];
            }
        });
    }); };
    var handleLoader = function () {
        pubsub.publish('apploading', true);
    };
    var fireLogout = function () {
        logout()
            .then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                localforage.clear();
                localStorage.removeItem('dismissSplash');
                Cookies.remove('userStateToken');
                localStorage.removeItem('pageRefreshStatus');
                localStorage.removeItem('hidePersonalizationBanner');
                pubsub.publish('dispose-cookies', 'token');
                pubsub.publish('apploading', false);
                pubsub.publish('user-analytics', { ename: ANALYTICS.LOGOUT });
                window && (window === null || window === void 0 ? void 0 : window.AE) && ((_a = window.AE) === null || _a === void 0 ? void 0 : _a.logout());
                window.location.assign("/");
                return [2 /*return*/, res.data];
            });
        }); })
            .catch(function (e) {
            console.error(e);
            pubsub.publish('apploading', false);
            return e;
        });
    };
    var checkPath = function (type) { return __awaiter(void 0, void 0, void 0, function () {
        var currentQueryParams, params, isRokuBox, compliance, flowUrls, userInfo, isHba;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    currentQueryParams = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) || "";
                    params = new URLSearchParams(currentQueryParams);
                    isRokuBox = params.get("device") === "roku_box";
                    compliance = (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.site) === null || _c === void 0 ? void 0 : _c.settings) === null || _d === void 0 ? void 0 : _d.compliance;
                    flowUrls = getFlowSteps(compliance);
                    if (!(flowUrls === null || flowUrls === void 0 ? void 0 : flowUrls.includes("/checkout"))) return [3 /*break*/, 1];
                    return [2 /*return*/, navigate("/checkout?planId=TVE")];
                case 1:
                    if (type === "tve")
                        return [2 /*return*/, navigate("/tve".concat(isRokuBox ? currentQueryParams : ""))];
                    return [4 /*yield*/, localforage.getItem("AuthenticationStore")];
                case 2:
                    userInfo = _f.sent();
                    if (!(userInfo && ((_e = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user) === null || _e === void 0 ? void 0 : _e.userId))) return [3 /*break*/, 4];
                    return [4 /*yield*/, checkForHBA()];
                case 3:
                    isHba = _f.sent();
                    if (!isHba)
                        return [2 /*return*/, navigate("/locate".concat(isRokuBox ? currentQueryParams : ""))];
                    _f.label = 4;
                case 4: return [2 /*return*/, navigate("/viewplans")];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null, !!(moduleData === null || moduleData === void 0 ? void 0 : moduleData.length) && showMasthead && (React.createElement("div", { className: 'vertical-header', style: __assign(__assign({}, getBackgroundColor()), navigationFonts) },
        React.createElement("div", { className: 'vertical-navigation' },
            React.createElement("div", { className: "logo-image" }, desktopLogo &&
                React.createElement(Link, { to: "/", onClick: function () { return switchBetweenPages(); } },
                    React.createElement("img", { src: desktopLogo, alt: "Logo" }))),
            sponserLogo &&
                React.createElement("div", { className: "logo-image sponser" },
                    React.createElement("img", { height: 34, width: 62, src: sponserLogo, alt: "Logo" })),
            React.createElement(Navigation, { checkToShow: checkToShow, isMobile: false, navigation: siteConfigParser(siteConfig.appcmsPlatform, "navigation"), brand: siteConfigParser(siteConfig.appcmsMain.brand, "navigation") }),
            mvpd && mvpdLogo &&
                React.createElement("div", { className: "tve-provider-logo" },
                    React.createElement("img", { src: mvpdLogo, alt: "Provider Logo" })),
            (searchParams.get("device") !== "roku_box" && !access.user.isSubscribed && !access.user.tveUserId && (serviceTypes === null || serviceTypes === void 0 ? void 0 : serviceTypes.SVOD) && (((_w = window === null || window === void 0 ? void 0 : window.app_data) === null || _w === void 0 ? void 0 : _w.monetisationModelByCountry) === "SVOD")) && (React.createElement(SubscribeButton, { layoutSettings: (_x = moduleData === null || moduleData === void 0 ? void 0 : moduleData[0]) === null || _x === void 0 ? void 0 : _x.layout, handleLoader: handleLoader })),
            !access.user.tveUserId && serviceTypes.TVE && !((_y = access === null || access === void 0 ? void 0 : access.user) === null || _y === void 0 ? void 0 : _y.isSubscribed) ? React.createElement("div", { style: __assign(__assign({}, connectTvProviderCta), connectTvProviderCtaStyle), className: 'tvProviderButton site-color', onClick: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, checkPath("tve")];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                }); }); } }, ((_0 = (_z = moduleData === null || moduleData === void 0 ? void 0 : moduleData[0]) === null || _z === void 0 ? void 0 : _z.metadataMap) === null || _0 === void 0 ? void 0 : _0.connectTvProviderCta) || 'Connect TV Provider') : React.createElement(React.Fragment, null),
            access.user.userId === "" && React.createElement(LoginButton, { isVertical: true, layoutSettings: (_1 = moduleData === null || moduleData === void 0 ? void 0 : moduleData[0]) === null || _1 === void 0 ? void 0 : _1.layout, handleLoader: handleLoader }),
            access.user.userId && (React.createElement("div", { onMouseEnter: function () { return setUserMenu(true); }, onMouseLeave: function () { return setUserMenu(false); } },
                React.createElement("div", { className: "userMenu ".concat(userMenu ? "open" : "close") },
                    navigationItems.map(function (item) {
                        item.title === "Log In" ? navigationSettings.pop() : navigationSettings;
                        return (React.createElement("div", null,
                            React.createElement(Link, { className: "navigation-link-dropDown", to: item.url }, item.title)));
                    }),
                    React.createElement("div", { style: logoutCta, className: "navigation-link-dropDown", onClick: function () { return fireLogout(); } },
                        React.createElement("span", null, ((_6 = (_5 = (_4 = (_3 = (_2 = window === null || window === void 0 ? void 0 : window.app_data) === null || _2 === void 0 ? void 0 : _2.appcmsPlatform) === null || _3 === void 0 ? void 0 : _3.navigation) === null || _4 === void 0 ? void 0 : _4.settings) === null || _5 === void 0 ? void 0 : _5.primaryCta) === null || _6 === void 0 ? void 0 : _6.logoutCtaText) || "Log Out"))))))))));
};
export default VerticalMasthead;
